import apiUrl from "../config/apiUrl";
import { OrderRegisterLimitModel } from "../models/request/OrderRegisterLimit.model";
import fetchUrl from "../utils/fetchUrl";
import { IHttpResponse } from "../models/HttpResponse.model";
import { WalletLimitByUserResponse } from "../models/response";

export const ORDER_CANCEL = async (orderId: number) => {
  return await fetchUrl({
    url: `${apiUrl}order/cancel?orderId=${orderId}`,
    method: "GET",
  });
};
export const ORDER_FIND_ACTIVATED_BY_USER = async (
  page: number,
  perPage: number,
  symbol?: string
) => {
  let queries = `order/find-activated-by-user?page=${page}&size=${perPage}`;
  if (symbol) {
    queries = queries + `&symbol=${symbol}`;
  }
  return await fetchUrl({
    url: `${apiUrl}${queries}`,
    method: "GET",
  });
};
export const ORDER_FIND_HISTORY_BY_USER = async (
  page: number,
  perPage: number,
  symbol?: string
) => {
  let queries = `order/find-history-by-user?page=${page}&size=${perPage}`;
  if (symbol) {
    queries = queries + `&symbol=${symbol}`;
  }
  return await fetchUrl({
    url: `${apiUrl}${queries}`,
    method: "GET",
  });
};
export const ORDER_FIND_LAST_15_TRADE = async (symbol?: string) => {
  const url = `${apiUrl}order/find-last-15-trade?symbol=${symbol}`;
  return await fetchUrl({
    url: url,
    method: "GET",
  });
};
export const ORDER_FIND_MARKET_LIST = async (symbol?: string) => {
  return await fetchUrl({
    url: `${apiUrl}order/find-market-list?symbol=${symbol}`,
    method: "GET",
    body: {},
  });
};
export const ORDER_REGISTER_LIMIT = async (data: OrderRegisterLimitModel) => {
  return await fetchUrl({
    url: `${apiUrl}order/register-limit`,
    method: "POST",
    body: data,
  });
};
// market-ask or market-bid
export const ORDER_REGISTER_MARKET = async (
  mode: string,
  target: string,
  symbol?: string,
  amountOrValue?: number
) => {
  const url = `${apiUrl}order/register-market-${target}`;
  let data: any = {
    amount: undefined,
    symbol: `${symbol}`,
    volume: undefined,
  };
  if (mode === "ASK") {
    data.volume = amountOrValue;
  } else {
    data.amount = amountOrValue;
  }
  return await fetchUrl({
    url: url,
    method: "POST",
    body: data,
  });
};
export const ORDER_USER_LAST_MONTH_REPORT = async () => {
  return await fetchUrl({
    url: `${apiUrl}order/user-last-month-report`,
    method: "GET",
  });
};

export const GET_WALLET_LIMIT_BY_USER = async (): Promise<
  IHttpResponse<WalletLimitByUserResponse>
> => {
  const url = `${apiUrl}order/walletLimitByUser`;
  return await fetchUrl({
    url: url,
    method: "GET",
  });
};
